import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { push, replace, goBack } from 'react-router-redux';
import {
  updateProps as updatePropsAction,
  updateFilters as updateFiltersAction,
  updateTemplateProps as updateTemplatePropsAction,
  updateDraftProps as updateDraftPropsAction,
  getTemplates as getTemplatesAction,
  createDraft as createDraftAction,
  deleteTemplate as deleteTemplateAction,
  deleteDraft as deleteDraftAction,
  getContractsCount as getContractsCountAction,
  getLocationsAndProducts as getLocationsAndProductsAction,
  saveNewTemplateName as saveNewTemplateNameAction,
  updateLocationProps as updateLocationPropsAction,
  downloadPdfZip as downloadPdfZipAction,
  archiveUnarchive as archiveUnarchiveAction,
} from '../../../../stores/contracting/template-list/template-list-actions';
import List from './list';
import LoadingOverlay from '../../../tc-ui/loading-overlay';
import CreateDraftDialog from '../create-template-draft/in-dialog';
import CreateGroupDialog from '../create-group/create-group-dialog';

import R from 'ramda';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

class MainTemplatesListContainer extends Component {
  componentWillMount() {
    document.title = 'Templates';
    const { getLocationsAndProducts, updateProps, locations, getTemplates } = this.props;
    if (isNilOrEmpty(locations)) getLocationsAndProducts();
    const query = R.propOr({}, 'query', location);
    if (!isNilOrEmpty(query)) updateProps(query);
    getTemplates();
  }
  componentDidMount() {
    if (this.props.location.search) {
      this.updateSearchFiltersFromQuery(this.props.location.query);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.updateSearchFiltersFromQuery(nextProps.location.query);
    }
  }
  onExpandChange = (docs, locationId, expandedName, expanded) => {
    const { updateLocationProps } = this.props;
    updateLocationProps({ locationId, value: { [expandedName]: !expanded } });
    // const templateIds = docs.filter(doc => isNaN(doc.partnersCount)).map(R.prop('_id'));
    // if (!R.isEmpty(templateIds)) this.props.getContractsCount(templateIds);
  };
  getRouteName = (pathname) => {
    const { location } = this.props;
    return R.call(R.cond([
      [R.contains('draft'), R.always('drafts')],
      [R.contains('template-groups'), R.always('groups')],
      [R.T, R.always('templates')],
    ]), pathname || location.pathname);
  };

  updateSearchFiltersFromQuery= (query) => {
    const updatedQ = R.mapObjIndexed((val, key) => {
      if (R.contains('Filter', key) && R.is(String, val)) return [val];
      if (key === 'searchingAllYears') return val === 'true';
      return val;
    }, query);
    this.props.updateFilters(updatedQ);
  };
  changeRoute = (route) => this.props.router.push(`/contracting/${route}`);
  createDraft = () => {
    const {
      newDraftStartDate,
      newDraftEndDate,
      locations,
      newDraftName,
      updateProps,
      createDraft,
      draftRateType,
      draftCommissionPercentage,
      draftNettCommission,
    } = this.props;
    const updatedContactInfoComplete = contactInfo => (
      contactInfo.address
      && (
        contactInfo.address.address_1
        || contactInfo.formattedAddress
      )
      && contactInfo.phone
      && contactInfo.firstName
      && contactInfo.lastName);
    const locationsValid = locations.filter(R.propEq('checked', true)).every(loc => loc.contactInfoComplete || updatedContactInfoComplete(loc.contactInfo));
    const dataValid = R.call(R.allPass([
      () => newDraftStartDate,
      () => newDraftEndDate,
      () => R.any(R.propEq('checked', true), locations),
      () => newDraftName,
      () => locationsValid,
    ]));
    if (dataValid) {
      createDraft({
        startDate: newDraftStartDate,
        endDate: newDraftEndDate,
        locations,
        templateName: newDraftName,
        draftRateType,
        draftCommissionPercentage,
        draftNettCommission,
      })
        .then(res => {
          const draftsLength = R.pathOr(0, ['payload', 'drafts', 'length'], res);
          const firstDraft = R.pathOr({}, ['payload', 'drafts', 0], res);
          if (draftsLength > 1) this.props.router.push('/contracting/template-list');
          if (draftsLength === 1) this.props.router.push(`/contracting/draft/${firstDraft.originalContractId}/details`);
        });
    }
    else updateProps({ createDraftError: 'Please fill all required fields' });
  };
  render() {
    const route = this.getRouteName();
    const { sendTemplateDialogOpen, contractsSent, templateToBeSent, templateGroupToBeSent, ...extraProps } = this.props;
    const {
      updateProps,
      showLoadingOverlay,
      overlayText,
    } = extraProps;
    const allProps = {
      ...extraProps,
      onExpandChange: this.onExpandChange,
      router: this.props.router,
      route,
    };
    return (
      <div style={{ width: '100%' }}>
        <List {...allProps} />
        <LoadingOverlay loading={showLoadingOverlay} text={overlayText}/>
        <CreateDraftDialog updateProps={updateProps} createDraft={this.createDraft} />
        <CreateGroupDialog updateProps={updateProps} getTemplates={extraProps.getTemplates} />
      </div>
    );
  }
}

MainTemplatesListContainer.propTypes = {
  children: PropTypes.node,
  templateToBeSent: PropTypes.object,
  templateGroupToBeSent: PropTypes.object,
  drafts: PropTypes.array,
  templates: PropTypes.array,
  locations: PropTypes.array,
  templatesLoaded: PropTypes.bool,
  showLoadingOverlay: PropTypes.bool,
  overlayText: PropTypes.string,
  sendTemplateDialogOpen: PropTypes.bool,
  contractsSent: PropTypes.bool,
  isSingleLoc: PropTypes.bool,
  updateProps: PropTypes.func,
  listRefreshing: PropTypes.bool,
  updateTemplateProps: PropTypes.func,
  updateDraftProps: PropTypes.func,
  deleteTemplate: PropTypes.func,
  deleteDraft: PropTypes.func,
  getContractsCount: PropTypes.func,
  getLocationsAndProducts: PropTypes.func,
  getTemplates: PropTypes.func,
  updateLocationProps: PropTypes.func,
  router: PropTypes.object,
  updateFilters: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = ({ contracting, user }) => ({
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
  ...contracting.templateList.toJS(),
  currentYear: contracting.currentYear,
  allContractPeriods: contracting.contractPeriods,
});

const mapDispatchToProps = dispatch => ({
  updateProps: payload => dispatch(updatePropsAction(payload)),
  updateTemplateProps: (...args) => dispatch(updateTemplatePropsAction(...args)),
  updateDraftProps: (...args) => dispatch(updateDraftPropsAction(...args)),
  deleteTemplate: (...args) => dispatch(deleteTemplateAction(...args)),
  deleteDraft: (...args) => dispatch(deleteDraftAction(...args)),
  getTemplates: () => dispatch(getTemplatesAction()),
  getLocationsAndProducts: () => dispatch(getLocationsAndProductsAction()),
  createDraft: (...args) => dispatch(createDraftAction(...args)),
  getContractsCount: (...args) => dispatch(getContractsCountAction(...args)),
  updateLocationProps: (...args) => dispatch(updateLocationPropsAction(...args)),
  saveNewTemplateName: R.curry((templateOrDraft, id, newName) => {
    if (newName && newName.trim()) dispatch(saveNewTemplateNameAction(templateOrDraft, id, newName));
    else window.alert('Template name cannot be empty.');
  }),
  downloadPdfZip: (...args) => dispatch(downloadPdfZipAction(...args)),
  archiveUnarchive: (...args) => dispatch(archiveUnarchiveAction(...args)),
  router: {
    push: (...args) => dispatch(push(...args)),
    replace: (...args) => dispatch(replace(...args)),
    goBack: (...args) => dispatch(goBack(...args)),
  },
  updateFilters: (...args) => dispatch(updateFiltersAction(...args)),
});
export default connect(mapStateToProps, mapDispatchToProps)(MainTemplatesListContainer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/container.jsx